import type { User } from '@supabase/supabase-js'

export function isPulseEmailVerified(user: User | null | undefined): boolean {
  if (!user) return false
  if (!user.email) return true
  return Boolean(user.email_confirmed_at)
}
